var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      Array.isArray(_vm.rowData[_vm.fieldData.fieldCode])
        ? _vm._l(
            _vm.rowData[_vm.fieldData.fieldCode],
            function (val, valIndex) {
              return _c("p", { key: valIndex }, [_vm._v(_vm._s(val))])
            }
          )
        : [_vm._v(_vm._s(_vm.rowData[_vm.fieldData.fieldCode]))],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }